/* eslint-disable max-len */
export const defaultConfig = {
    booleans: {
        ENABLED_NAV_GLOBAL_TOKEN_INTERCEPTOR: false,
    },

    jsons: {},

    strings: {},

    numbers: {},
}

export type DefaultConfig = typeof defaultConfig
